import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { waitForAuthPr } from '../../../utils/authPrWake';

// Develop only, never translated: an authentication PR deploy may be asleep, so wait for it before booting.
export default function WaitForAuthPr({ authPr, authUrl, placeholder, children }) {
    const [ready, setReady] = useState(false);
    const [waking, setWaking] = useState(false);
    useEffect(() => {
        waitForAuthPr(authUrl, { onWaiting: () => setWaking(true) }).then(() => setReady(true));
    }, [authUrl]);
    if (ready) return children;
    return placeholder(waking ? `Waking up authentication PR #${authPr}` : 'Loading');
}

WaitForAuthPr.propTypes = {
    authPr: PropTypes.string.isRequired,
    authUrl: PropTypes.string.isRequired,
    placeholder: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};
